import { createAction, props } from '@ngrx/store';
import {ScreeningSettingsDTO} from '../../dto/screening-settings';

export const loadScreeningSettings = createAction(
  '[ScreeningSetting] Load ScreeningSettings',
  props<{ projectId: number }>()
);
export const loadScreeningSettingsSuccess = createAction(
  '[ScreeningSetting] Load ScreeningSettings Success',
  props<{ projectId: number; setting: ScreeningSettingsDTO }>()
);
export const loadScreeningSettingsFailure = createAction(
  '[ScreeningSetting] Load ScreeningSettings Failure',
  props<{ projectId: number; error: any }>()
);

export const generateScreeningSetting = createAction(
  '[ScreeningSetting] Create ScreeningSetting',
  props<{ projectId: number; }>()
);
export const generateScreeningSettingSuccess = createAction(
  '[ScreeningSetting] Create ScreeningSetting Success',
  props<{ projectId: number; setting: ScreeningSettingsDTO }>()
);
export const generateScreeningSettingFailure = createAction(
  '[ScreeningSetting] Create ScreeningSetting Failure',
  props<{ projectId: number; error: any }>()
);


export const updateScreeningSetting = createAction(
  '[ScreeningSetting] Update ScreeningSetting',
  props<{ projectId: number; id: number; setting: ScreeningSettingsDTO }>()
);
export const updateScreeningSettingSuccess = createAction(
  '[ScreeningSetting] Update ScreeningSetting Success',
  props<{ projectId: number; setting: ScreeningSettingsDTO }>()
);
export const updateScreeningSettingFailure = createAction(
  '[ScreeningSetting] Update ScreeningSetting Failure',
  props<{ projectId: number; error: any }>()
);
